import script from "./AbstractMentoringClose.vue?vue&type=script&setup=true&lang=js"
export * from "./AbstractMentoringClose.vue?vue&type=script&setup=true&lang=js"

import "./AbstractMentoringClose.vue?vue&type=style&index=0&id=294edd91&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-294edd91"]])

export default __exports__